import React, { useEffect } from 'react';
const defaultRowsPerPage = 5;
const defaultPage = 0;
const rowsPerPageOptions = [5, 10, 20, 50];
const totalRowCount = 500;
export const useDataTablePagination = ({ data }) => {
    const [page, setPage] = React.useState(defaultPage);
    const [rowsPerPage, setRowsPerPage] = React.useState(defaultRowsPerPage);
    const rows = paginate({ page, pageSize: rowsPerPage, array: data });
    useEffect(() => {
        setPage(0);
    }, [data]);
    return {
        page,
        onPageChange: setPage,
        rowsPerPage,
        onRowsPerPagePageChange: setRowsPerPage,
        rows,
        rowsPerPageOptions,
        totalRowCount,
    };
};
const paginate = ({ page, pageSize, array }) => {
    const clonedArray = structuredClone(array);
    const start = page * pageSize;
    const end = start + pageSize;
    const portion = clonedArray.slice(start, end);
    return portion;
};
